export default [
    {value: "xs", label: "XS"},
    {value: "s", label: "Small"},
    {value: "m", label: "Medium"},
    {value: "l", label: "Large"},
    {value: "xl", label: "XL"}
];